<script>
	import { onMount } from 'svelte';
	import { injectGlobalStyles, gameUrl, normalizeText, loadJson } from './shared.js';

	export let game = null;
	export let src = '';
	export let teamId = '';
	export let tag = '';
	export let compId = '';

	let host;

	function openGame() {
		const id = game?.game?.id;
		if (!id) return;
		window.location.href = gameUrl(id, { tag, teamId, compId });
	}

	onMount(() => {
		const root = host?.getRootNode();
		if (root instanceof ShadowRoot) injectGlobalStyles(root);
	});

	// If a src is provided, load game data from it
	onMount(async () => {
		if (src && !game) {
			try {
				const data = await loadJson(src);
				// If the endpoint returns wrapper, use it directly
				game = data?.game ? data : data;
			} catch (err) {
				// ignore load errors, leave game as-is
				console.error('GameCard load error:', err);
			}
		}
	});
</script>

<div class="game-card" bind:this={host} role="button" tabindex="0" on:click={openGame} on:keypress={openGame}>
	<div class="game-card__team game-card__team--left">
		{#if game.team1?.logo}
			<img class="game-card__logo" src={game.team1.logo} alt={game.team1?.name || 'team'}>
		{:else}
			<div class="game-card__logo-placeholder">{(game.team1?.shortName?.[0] || game.team1?.name?.[0] || 'T').toUpperCase()}</div>
		{/if}
		<span class="game-card__team-name">{game.team1?.shortName || game.team1?.name || '—'}</span>
	</div>

	<div class="game-card__center">
		<div class="game-card__comp">{game.comp?.name || game.comp?.abcName || '—'}</div>
		<div class="game-card__score-block">
			{#if (game.game?.score1 !== null && game.game?.score1 !== undefined) || (game.game?.score2 !== null && game.game?.score2 !== undefined)}
				<span class="game-card__score-value">{game.game?.score1 ?? '-'}</span>
				<span class="game-card__score-dash">:</span>
				<span class="game-card__score-value">{game.game?.score2 ?? '-'}</span>
			{:else}
				<span class="game-card__no-score">—</span>
			{/if}
		</div>
		<div class="game-card__datetime">
			<span class="game-card__date">{game.game?.localDate || '—'}</span>
			<span class="game-card__separator">•</span>
			<span class="game-card__time">{game.game?.localTime || '—'}</span>
			<span class="game-card__separator">•</span>
			<span class="game-card__arena">{game.arena?.shortName || game.arena?.name || '—'}</span>
		</div>
	</div>

	<div class="game-card__team game-card__team--right">
		<span class="game-card__team-name">{game.team2?.shortName || game.team2?.name || '—'}</span>
		{#if game.team2?.logo}
			<img class="game-card__logo" src={game.team2.logo} alt={game.team2?.name || 'team'}>
		{:else}
			<div class="game-card__logo-placeholder">{(game.team2?.shortName?.[0] || game.team2?.name?.[0] || 'T').toUpperCase()}</div>
		{/if}
	</div>
</div>

<style>
	:host { display: block; }
	.game-card {
		display: flex;
		align-items: center;
		gap: 0;
		padding: 12px;
		border: 1px solid #d7dce2;
		border-radius: 12px;
		background: #fff;
		cursor: pointer;
		transition: box-shadow 0.2s ease, transform 0.2s ease;
	}
	.game-card:hover { box-shadow: 0 6px 18px rgba(0,36,77,0.16); transform: translateY(-2px); }
	.game-card__team { display:flex; align-items:center; gap:8px; flex:0 0 20%; min-width:110px; }
	.game-card__team--right { flex-direction: row-reverse; justify-content: flex-end; }
	.game-card__logo, .game-card__logo-placeholder { width:40px; height:40px; border-radius:8px; object-fit:cover; background:#edf2f7; flex:0 0 40px; }
	.game-card__logo-placeholder { display:flex; align-items:center; justify-content:center; font-size:14px; font-weight:700; color:#00244d; }
	.game-card__team-name { font-size:14px; font-weight:600; color:#122033; line-height:1.2; }
	.game-card__center { flex:1 1 60%; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:6px; min-width:200px; padding:0 16px; }
	.game-card__comp { font-size:12px; color:#6b7a90; text-transform:uppercase; font-weight:600; line-height:1; }
	.game-card__score-block { display:flex; align-items:center; gap:6px; justify-content:center; }
	.game-card__score-value { font-size:24px; font-weight:700; color:#122033; width:30px; text-align:center; line-height:1; }
	.game-card__score-dash { color:#6b7a90; font-size:20px; font-weight:700; }
	.game-card__no-score { font-size:20px; color:#6b7a90; }
	.game-card__datetime { display:flex; align-items:center; gap:4px; font-size:12px; color:#53657b; line-height:1; justify-content:center; flex-wrap:wrap; }
	.game-card__date, .game-card__time { font-weight:600; }
	.game-card__separator { color:#d7dce2; }
	.game-card__arena { text-align:center; }
	@media (max-width:640px) {
		.game-card { flex-direction:column; align-items:stretch; gap:8px; padding:12px; }
		.game-card__team { flex:0 0 auto; }
		.game-card__center { flex:1; min-width:auto; padding:8px 0; }
	}
</style>
